import { render, staticRenderFns } from "./MonotributoInfo.vue?vue&type=template&id=6ffa4b36&"
import script from "./MonotributoInfo.vue?vue&type=script&lang=js&"
export * from "./MonotributoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports